import axios from 'axios'

const API = (process.env.REACT_APP_API_URL || 'http://localhost:3001/api').replace('/api','') + '/api'

const sa = axios.create({ baseURL: API })

sa.interceptors.request.use(config => {
  const token = localStorage.getItem('sa_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

sa.interceptors.response.use(r => r, err => {
  if (err.response?.status === 401 || err.response?.status === 403) {
    localStorage.removeItem('sa_token')
    localStorage.removeItem('sa_user')
    window.location.href = '/superadmin'
  }
  return Promise.reject(err)
})

export const saLogin        = (email, senha) => sa.post('/sa/login', { email, senha })
export const saDashboard    = () => sa.get('/sa/dashboard')
export const saOrgaos       = () => sa.get('/sa/orgaos')
export const saOrgao        = (id) => sa.get(`/sa/orgaos/${id}`)
export const saCriarOrgao   = (dados) => sa.post('/sa/orgaos', dados)
export const saAtualizarOrgao = (id, dados) => sa.put(`/sa/orgaos/${id}`, dados)
export const saSuspender    = (id, motivo) => sa.post(`/sa/orgaos/${id}/suspender`, { motivo })
export const saReativar     = (id) => sa.post(`/sa/orgaos/${id}/reativar`)
export const saCriarAdmin   = (id, dados) => sa.post(`/sa/orgaos/${id}/criar-admin`, dados)
export const saEditarAdmin  = (orgaoId, userId, dados) => sa.put(`/sa/orgaos/${orgaoId}/usuarios/${userId}`, dados)
export const saExcluirAdmin = (orgaoId, userId) => sa.delete(`/sa/orgaos/${orgaoId}/usuarios/${userId}`)
export const saResetarSenha = (orgaoId, userId) => sa.post(`/sa/orgaos/${orgaoId}/usuarios/${userId}/resetar-senha`)

export default sa
